module.exports = __webpack_public_path__ + "img/whatsapp_logo.3e4768d1.png";